import fp from 'lodash/fp'

const convertBlobToJson = (data) => {
  if (!(data instanceof Blob)) {
    return Promise.resolve(data)
  }

  return new Promise((resolve, reject) => {
    const reader = new FileReader()
    const toTry = (handler) => (data) => {
      try {
        handler(data)
      } catch (err) {
        reject(err)
      }
    }

    reader.onload = toTry(({ target }) => {
      resolve(JSON.parse(target.result))
    })
    reader.onerror = reject

    toTry(reader.readAsText.bind(reader))(data)
  })
}

const readFile = (file) => {
  const reader = new FileReader()

  return new Promise((resolve, reject) => {
    reader.addEventListener('loadend', () => {
      resolve(reader.result)
    })

    reader.addEventListener('error', () => {
      reject(reader.error)
    })

    reader.readAsArrayBuffer(file)
  })
}

// TODO: asap() mb be used here to avoid thread stopping
const chunkArrayBuffer = fp.curry((chunkSize, arrayBuffer) => {
  const chunkCount = Math.ceil(arrayBuffer.byteLength / chunkSize)

  return fp.times((i) => {
    const offset = i * chunkSize
    return arrayBuffer.slice(offset, offset + chunkSize)
  }, chunkCount)
})

export { convertBlobToJson, readFile, chunkArrayBuffer }
